export default __webpack_public_path__ + "static/media/signboard.5363b4ca.png";